export default __webpack_public_path__ + "static/media/Freebooter's Arm-straps of Pierced Flesh.695830d1.jpg";